import React from 'react';
import styles from './Photo.module.scss';
import theme from 'styles/theme.module.scss'; 
import { IconLoader, IconTrash, IconPlus, IconAlertTriangle, IconUpload } from '@tabler/icons-react';


export interface PhotoProps {
    src: string | undefined;
    label?: string;
    state: 'active' | 'loading' | 'error' | 'new' | 'upload';
    onClick?: () => void;
}

const Photo = ({ src, label, state, onClick, ...rest }: PhotoProps) => {
    return (
        <div 
            className={`${styles.photoContainer} ${state === 'loading' ? styles.disabled : ''}`}
        >
            <button 
                className={styles.photoBtn} 
                onClick={onClick} 
                disabled={state === 'loading'}
            >
                {state === "active" && (
                    <img src={src} alt={label || 'Captured Image'} className={styles.photo} />
                )}
                {state === "loading" && (
                    <>
                        <img src={src} alt={label || 'Captured Image'} className={`${styles.photo} ${styles.grayedOut}`} />
                        <div className={styles.iconOverlay}>
                            <IconLoader className={`${styles.icon} ${styles.loadingIcon}`} />
                        </div>
                    </>
                )}
                {state === "error" && (
                    <>
                        <img src={src} alt={label || 'Captured Image'} className={`${styles.photo} ${styles.grayedOut}`} />
                        <div className={styles.iconOverlay}>
                            <IconAlertTriangle className={styles.icon} />
                        </div>
                    </>
                )}
                {state === "new" && (
                    <div className={styles.placeholder}>
                        <IconPlus className={styles.icon} />
                    </div>
                )}
                {state === "upload" && (
                    <div className={styles.placeholder}>
                        <IconUpload className={styles.icon} />
                    </div>
                )}
            </button>
            {label && (
                <span className={`${theme.caption} ${styles.caption} ${state === 'active' ? theme.mono : ''}`}>
                    {label}
                </span>
            )}
        </div>
    );
};



export default Photo;